import { css } from "@/utils/css";
import { __ } from "@wordpress/i18n";
import { PdfUpload } from "./pdf-upload";
import { WebsiteURL } from "./website-url";
import { useMemo } from "@wordpress/element";
import { useRoute } from "@/hooks/use-route";
import { Tabs } from "@/components/tabs";
import { WordPressPosts } from "./wordpress-posts";
import { CustomText } from "./custom-text";
import { BsWordpress } from "react-icons/bs";
import { TbWorldWww } from "react-icons/tb";
import { FaFilePdf } from "react-icons/fa6";
import { ImFileText } from "react-icons/im";
import { Overview } from "./overview";
import { useKnowledgeBaseStats } from "@/hooks/use-knowledge-base";
import { IS_PRO } from "@/utils/constants";

export const tabs = [
    {
        value: "overview",
        label: __("Overview", "antimanual"),
        element: <Overview />,
    },
    {
        value: "wp",
        label: __("WordPress Posts", "antimanual"),
        description: __("Add your existing WordPress posts to the knowledge base.", "antimanual"),
        icon: <BsWordpress />,
        element: <WordPressPosts />,
    },
    {
        value: "pdf",
        label: __("PDF Upload", "antimanual"),
        description: __("Upload a PDF document and add the extracted data to the knowledge base.", "antimanual"),
        icon: <FaFilePdf />,
        element: <PdfUpload />,
    },
    {
        value: "url",
        label: __("Website URL", "antimanual"),
        description: __("Add a website URL and add the crawled content to the knowledge base.", "antimanual"),
        icon: <TbWorldWww />,
        element: <WebsiteURL />,
    },
    {
        value: "txt",
        label: __("Custom Text", "antimanual"),
        description: __("Paste or type any text you like to create a fully customized dataset, from short notes to full articles.", "antimanual"),
        icon: <ImFileText />,
        element: <CustomText />,
    },
];

export default function KnowledgeBase() {
    const { updateQuery, query } = useRoute();
    const { data: stats } = useKnowledgeBaseStats();

    const activeTab = useMemo(() => {
        const foundTab = tabs.find((tab) => tab.value === query.tab);
        return foundTab || tabs[0];
    }, [query.tab]);

    return (
        <div className={css("knowledge-base")}>
            <Tabs
                standalone
                tabs={tabs.map((tab) => {
                    if (tab.value === "overview") {
                        return tab;
                    }

                    let total = stats?.find((stat) => stat.type === tab.value)?.total || 0;
                    let newLabel = total > 0 ? `${tab.label} (${total})` : tab.label;

                    return { ...tab, label: newLabel };
                })}
                activeTab={activeTab.value}
                onTabChange={(tab) => updateQuery({ page: query.page, tab }, true)}
            />
            {activeTab.value === "overview" ? (
                <div className={css("mt-5")}>
                    <Overview onTabChange={(tab) => updateQuery({ page: query.page, tab }, true)} />
                </div>
            ) : (
                <>
                    <div className={css("pb-5 pt-2 px-2")}>
                        <h2>{activeTab.label}</h2>
                        <p>{activeTab.description || ""}</p>
                    </div>
                    <div className={css("kb-content")}>{activeTab.element}</div>
                </>
            )}
        </div>
    );
}
